import { render, staticRenderFns } from "./CartableStatuses.vue?vue&type=template&id=8d848766&"
import script from "./CartableStatuses.vue?vue&type=script&lang=js&"
export * from "./CartableStatuses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports